import { render, staticRenderFns } from "./ConversationAvatar.vue?vue&type=template&id=dd29edc6&scoped=true"
import script from "./ConversationAvatar.vue?vue&type=script&lang=ts"
export * from "./ConversationAvatar.vue?vue&type=script&lang=ts"
import style0 from "./ConversationAvatar.vue?vue&type=style&index=0&id=dd29edc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd29edc6",
  null
  
)

export default component.exports